<!-- Top Notification Bar -->
<div
  *ngIf="topSnackbarVisible"
  class="top-notification-bar"
>
  <div class="notification-content">
    <div class="notification-text">
      <i class="pi pi-megaphone"></i>
      <span>Grow your visibility across sports enthusiasts and fans.</span>
    </div>
    <div class="notification-actions">
      <a href="https://www.chaseyoursport.com/advertise" target="_blank" class="cta-link">
        Get Started
      </a>
      <button class="close-btn" (click)="toggleTopSnackbar()" aria-label="Close notification">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
</div>

<!-- Modern Navigation Header -->
<header class="modern-nav-header">
  <nav class="nav-container">
    <!-- Mobile Menu Toggle -->
    <button 
      class="mobile-menu-toggle" 
      (click)="sidebarVisible = true" 
      aria-label="Open Menu"
      [class.active]="sidebarVisible">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- Logo Section -->
    <div class="brand-logo" routerLink="/">
      <img
        src="/assets/images/sports-social-logo.png"
        alt="Chase Your Sport Logo"
        class="logo-image"
      />
      <div class="brand-text">
        <p class="brand-title">Chase Your Sport</p>
        <p class="brand-subtitle">Sports Social Blog</p>
      </div>
    </div>

    <!-- Desktop Navigation Links -->
    <div class="nav-links desktop-nav">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link">
        <i class="pi pi-home"></i>
        <span>Home</span>
      </a>
      
      <div class="nav-dropdown" 
           (mouseenter)="showTopicsDropdown = true" 
           (mouseleave)="showTopicsDropdown = false">
        <a class="nav-link dropdown-trigger">
          <i class="pi pi-tags"></i>
          <span>Topics</span>
          <i class="pi pi-chevron-down dropdown-arrow"></i>
        </a>
        <div class="dropdown-menu" [class.show]="showTopicsDropdown">
          <div class="dropdown-content">
            <div class="dropdown-section">
              <p class="dropdown-title">Trending Topics</p>
              <a 
                *ngFor="let topic of trendingTopics.slice(0, 6)" 
                [routerLink]="'/' + slugify(topic.topicName)"
                class="dropdown-item">
                <i class="pi pi-bookmark"></i>
                {{ topic.topicName }}
              </a>
            </div>
            <div class="dropdown-section">
              <a routerLink="/topic/explore-topics" class="dropdown-item featured">
                <i class="pi pi-compass"></i>
                Explore All Topics
              </a>
            </div>
          </div>
        </div>
      </div>

      <a routerLink="/quiz" routerLinkActive="active" class="nav-link quiz-link">
        <i class="pi pi-trophy"></i>
        <span>Quizzes</span>
        <span class="nav-badge">New</span>
      </a>

      <a routerLink="/search" routerLinkActive="active" class="nav-link">
        <i class="pi pi-search"></i>
        <span>Search</span>
      </a>
    </div>

    <!-- User Actions -->
    <div class="nav-actions">
      <!-- Desktop User Menu -->
      <div class="desktop-nav user-menu" *ngIf="isUserLoggedIn; else loginButton">
        <div class="user-profile" (click)="op.toggle($event)">
          <div class="user-avatar">
            <img
              *ngIf="userDetails?.profilePicture && !userDetails.profilePicture.includes('prod.sportsocial.in')"
              [src]="updateImageUrl(userDetails.profilePicture)"
              [alt]="userDetails.name"
            />
            <div
              *ngIf="!userDetails?.profilePicture || userDetails.profilePicture.includes('prod.sportsocial.in')"
              class="user-initials">
              {{ initials }}
            </div>
          </div>
          <div class="user-info">
            <span class="user-name">{{ userDetails?.name }}</span>
            <i class="pi pi-chevron-down"></i>
          </div>
        </div>
      </div>

      <ng-template #loginButton>
        <a routerLink="/login" class="login-btn desktop-nav">
          <i class="pi pi-sign-in"></i>
          <span>Sign In</span>
        </a>
      </ng-template>

      <!-- Contact Button -->
      <a routerLink="/contact" class="contact-btn desktop-nav">
        <i class="pi pi-envelope"></i>
        <span>Contact</span>
      </a>
    </div>
  </nav>
</header>

<!-- Modern Mobile Sidebar -->
<p-sidebar
  [(visible)]="sidebarVisible"
  position="left"
  styleClass="modern-sidebar"
  [modal]="true"
  [showCloseIcon]="false">
  
  <!-- Sidebar Header -->
  <div class="sidebar-header">
    <div class="sidebar-brand">
      <img src="/assets/images/sports-social-logo.png" alt="Logo" class="sidebar-logo" />
      <div class="sidebar-brand-text">
        <p class="sidebar-brand-heading">Chase Your Sport</p>
        <p>Sports Social Blog</p>
      </div>
    </div>
    <button class="sidebar-close" (click)="sidebarVisible = false">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- User Profile Section (Mobile) -->
  <div class="sidebar-user-section" *ngIf="isUserLoggedIn">
    <div class="sidebar-user-profile">
      <div class="sidebar-user-avatar">
        <img
          *ngIf="userDetails?.profilePicture && !userDetails.profilePicture.includes('prod.sportsocial.in')"
          [src]="updateImageUrl(userDetails.profilePicture)"
          [alt]="userDetails.name" />
        <div
          *ngIf="!userDetails?.profilePicture || userDetails.profilePicture.includes('prod.sportsocial.in')"
          class="sidebar-user-initials">
          {{ initials }}
        </div>
      </div>
      <div class="sidebar-user-info">
        <p class="user-name">{{ userDetails?.name }}</p>
        <p>Welcome back!</p>
      </div>
    </div>
  </div>

  <!-- Navigation Menu -->
  <div class="sidebar-nav">
    <!-- Main Navigation -->
    <div class="sidebar-section">
      <p class="sidebar-section-title">Navigation</p>
      <a routerLink="/" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-home"></i>
        <span>Home</span>
      </a>
      <a routerLink="/quiz" class="sidebar-nav-item quiz-item" (click)="sidebarVisible = false">
        <i class="pi pi-trophy"></i>
        <span>Quizzes</span>
        <span class="sidebar-badge">New</span>
      </a>
      <a routerLink="/search" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-search"></i>
        <span>Search</span>
      </a>
    </div>

    <!-- Topics Section -->
    <div class="sidebar-section">
      <p class="sidebar-section-title">
        <i class="pi pi-tags"></i>
        Trending Topics
      </p>
      <a
        *ngFor="let topic of trendingTopics.slice(0, 8)"
        [routerLink]="'/' + slugify(topic.topicName)"
        class="sidebar-nav-item topic-item"
        (click)="sidebarVisible = false">
        <i class="pi pi-bookmark"></i>
        <span>{{ topic.topicName }}</span>
      </a>
      <a routerLink="/topic/explore-topics" class="sidebar-nav-item explore-item" (click)="sidebarVisible = false">
        <i class="pi pi-compass"></i>
        <span>Explore All Topics</span>
      </a>
    </div>

    <!-- User Actions -->
    <div class="sidebar-section" *ngIf="isUserLoggedIn">
      <p class="sidebar-section-title">Account</p>
      <a routerLink="/user/profile" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-user"></i>
        <span>Profile</span>
      </a>
      <a routerLink="/user/create/article" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-pencil"></i>
        <span>Write Article</span>
      </a>
      <a routerLink="/user/edit-profile" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-user-edit"></i>
        <span>Edit Profile</span>
      </a>
      <a routerLink="/dashboard" class="sidebar-nav-item" 
         *ngIf="userRole === 'Admin' || userRole === 'Editor'"
         (click)="sidebarVisible = false">
        <i class="pi pi-briefcase"></i>
        <span>Dashboard</span>
      </a>
    </div>

    <!-- Contact & Info -->
    <div class="sidebar-section">
      <p class="sidebar-section-title">Get In Touch</p>
      <a routerLink="/about" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-info-circle"></i>
        <span>About</span>
      </a>
      <a routerLink="/contact" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-envelope"></i>
        <span>Contact</span>
      </a>
      <a routerLink="/advertise" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-megaphone"></i>
        <span>Advertise With Us</span>
      </a>
    </div>

    <!-- Legal -->
    <div class="sidebar-section">
      <p class="sidebar-section-title">Legal</p>
      <a routerLink="/privacy-policy" class="sidebar-nav-item" (click)="sidebarVisible = false">
        <i class="pi pi-shield"></i>
        <span>Privacy Policy</span>
      </a>
    </div>
  </div>

  <!-- Sidebar Footer -->
  <div class="sidebar-footer">
    <div *ngIf="!isUserLoggedIn" class="login-section">
      <a routerLink="/login" class="sidebar-login-btn" (click)="sidebarVisible = false">
        <i class="pi pi-sign-in"></i>
        <span>Sign In</span>
      </a>
    </div>
    <div *ngIf="isUserLoggedIn" class="logout-section">
      <button class="sidebar-logout-btn" (click)="signOut()">
        <i class="pi pi-sign-out"></i>
        <span>Sign Out</span>
      </button>
    </div>
  </div>
</p-sidebar>

<!-- Modern User Dropdown Menu -->
<p-overlayPanel #op styleClass="modern-user-dropdown">
  <div class="user-dropdown-header">
    <div class="user-dropdown-avatar">
      <img
        *ngIf="userDetails?.profilePicture && !userDetails.profilePicture.includes('prod.sportsocial.in')"
        [src]="updateImageUrl(userDetails.profilePicture)"
        [alt]="userDetails.name" />
      <div
        *ngIf="!userDetails?.profilePicture || userDetails.profilePicture.includes('prod.sportsocial.in')"
        class="user-dropdown-initials">
        {{ initials }}
      </div>
    </div>
    <div class="user-dropdown-info">
      <p class="user-name">{{ userDetails?.name }}</p>
      <p>{{ userDetails?.email }}</p>
    </div>
  </div>
  
  <div class="user-dropdown-divider"></div>
  
  <div class="user-dropdown-menu">
    <a routerLink="/user/profile" class="dropdown-menu-item">
      <i class="pi pi-user"></i>
      <span>View Profile</span>
    </a>
    
    <a routerLink="/user/create/article" class="dropdown-menu-item">
      <i class="pi pi-pencil"></i>
      <span>Write Article</span>
    </a>
    
    <a routerLink="/user/edit-profile" class="dropdown-menu-item">
      <i class="pi pi-user-edit"></i>
      <span>Edit Profile</span>
    </a>
    
    <div class="user-dropdown-divider" *ngIf="userRole === 'Admin' || userRole === 'Editor'"></div>
    
    <a routerLink="/dashboard" 
       class="dropdown-menu-item admin-item" 
       *ngIf="userRole === 'Admin' || userRole === 'Editor'">
      <i class="pi pi-briefcase"></i>
      <span>Dashboard</span>
    </a>
    
    <div class="user-dropdown-divider"></div>
    
    <button class="dropdown-menu-item logout-item" (click)="signOut()">
      <i class="pi pi-sign-out"></i>
      <span>Sign Out</span>
    </button>
  </div>
</p-overlayPanel>
